module.exports = __webpack_public_path__ + "img/view-only.7a3a7c63.svg";